


































































import { Vue, Component, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import dayjs from "dayjs";

import Loader from "@/modules/externals/components/Loader.vue";
import Paginate from "vuejs-paginate";
import EmptyTable from "../components/EmptyTable.vue";
import TableLoader from "@/modules/externals/components/TableLoader.vue";
import { FetchAuditPayload, ApplicantAudit, AuditList } from "../types";

const Applicants = namespace("applicant");

// eslint-disable-next-line @typescript-eslint/no-var-requires
const utc = require("dayjs/plugin/utc");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const timezone = require("dayjs/plugin/timezone");

dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
  components: {
    loader: Loader,
    paginate: Paginate,
    "empty-table": EmptyTable,
    "table-loader": TableLoader,
  },
})
export default class AuditLogTable extends Vue {
  @Prop({ required: true }) readonly entityId!: string;
  @Applicants.Getter("allApplicantAudits") allApplicantAudits: AuditList;
  @Applicants.Getter("isAllApplicantAuditEmpty") isAllApplicantAuditEmpty: boolean;
  @Applicants.Getter("allApplicantAudits") audits: ApplicantAudit[];
  @Applicants.Action("viewAllApplicantAudits") viewAllApplicantAudits: () => void;

  @Applicants.Action("fetchPaginatedApplicantAudits") fetchPaginatedApplicantAudits!: (
    payload: FetchAuditPayload
  ) => Promise<{}>;

  auditLog = [];
  isFetchingAuditLog = false;
  isAuditLogEmpty = false;
  totalPages = 1;
  loading = false;
  hasAuditError = false;
  applicantError = "";

  async fetch() {
    this.fetchPaginatedApplicantAudits({
      entityId: this.entityId,
      pageIndex: 1
    }).catch((err) => {
      this.hasAuditError = true;
      this.applicantError = err.message;
    });
  }

  async beforeMount() {
    await this.fetch();
  }

  fetchAllApplicantAudits() {
    this.viewAllApplicantAudits();
  }

  async changePage(pageNum: number) {
    this.loading = true;
    await this.fetchPaginatedApplicantAudits({ pageIndex: pageNum, entityId: this.entityId });
    this.loading = false;
  }

  localDate(date: string) {
    return dayjs(date).format("MMM D YYYY");
  }

  localTime(date: string) {
    return dayjs(date).format("h:mm a");
  }
}
